module.exports = __webpack_public_path__ + "static/media/oberflex-frakebariole-1200x2490.c6329d9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-frakebariole-1200x2490.jpg
// module id = 1016
// module chunks = 37